
import React from "react";
import CustomTable from "../../../../components/table/CustomTable";
import {SectionAccessUserTabTableApp} from "../Funtiomallity/SectionAccessUserTabTableApp";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SectionAccessUserTab =({
                                 setBodyForExport,
                                 setCriteria,
                                 finalArray,
                                 setSearchResults,
                                 searchResults,
                                 searchElement,
                                 setSearchElement,
                                 option,
                                 search,
                                 setSearch,
                                 setSimpleSearch,
                                 contractorId,
                                 supplierId,
                                 modified,
                                 setModified,
                                 setExpandImage
}) => {

    const {
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        rowsPerPage,
        getData
    } = SectionAccessUserTabTableApp({
        setBodyForExport,
        setCriteria,
        finalArray,
        setSearchResults,
        searchResults,
        searchElement,
        setSearchElement,
        modified,
        setModified,
        option,
        search,
        setSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        setExpandImage
    })

    return(
        <>
            <SearchSimple
                id={"txt_saut_search_simple"}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
                callApi={() => getData(0, { searchElement})}
                resetApi={() => getData(0, {searchElement: ''})}
            />
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={false}
                         thead={thead}
                         tbody={tbody}
                         columnActions={false}
                         textNotInformation={'no_information'}
                    />
            {pagination()}
        </>
    )
}

export default SectionAccessUserTab
